// extracted by mini-css-extract-plugin
module.exports = {"headlineText":"page_headlineText__USIho","contentText":"page_contentText__VDHPz","loading":"page_loading__U7RaB","loader":"page_loader__K54Je","l3":"page_l3__7tI6N"};